module.exports = __webpack_public_path__ + "img/3_124.7b7370a6.png";